export const SHOW_SAVE_TOAST = "SHOW_SAVE_TOAST";

export function showSavedToast(shouldShow) {
  return {
    type: SHOW_SAVE_TOAST,
    payload: shouldShow
  };
}
